// Core
import { Box, Flex, Grid, Text, Image, useColorMode, useColorModeValue, Tooltip, IconButton } from '@chakra-ui/react';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';

// Components
import Card from 'components/Card/Card';
import { Info2Icon } from 'components/Icons/Icons';

const Prizes = ({userData, countActivePlans, petrolEntriesAmount}) => { 
	const { colorMode, toggleColorMode } = useColorMode();
  	const isDark = colorMode === 'dark';

	const styleHeader = {
		color: '#099BFF',
		textAlign: 'center',
		fontSize: '18px',
		fontStyle: 'italic',
		fontWeight: '800',
		lineHeight: 'normal',
		textTransform: 'uppercase'
	};

	const styleCard = {
		padding: countActivePlans > 1 ? '18px 16px 10px 16px' : '16px',
		textAlign: 'center',
    	position: 'relative',
    	border: '1px solid #2ABDFD',
    	overflow: 'hidden',
    	background: 'transparent'
	};

	const ttpTextColor = useColorModeValue('#0E1633', '#E1E1E1');
    const ttpBgColor = useColorModeValue('white', '#0D234D');

	return (
		<Grid mt="18px" rowGap="10px" templateColumns={{ sm: '1fr', md: '1fr 1fr', lg: '1fr 1fr 1fr' }} gap="16px" templateRows='1fr'>
			<Card style={styleCard}>
				{ isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader} mt={countActivePlans > 1 ? '0px' : '12px' }>
		    		{ countActivePlans > 1 ? 
						'TOTAL ENTRIES AMOUNT' 
						: 'ENTRIES INCLUDED'
					}
		    	</Text>
		    	<Text variant="title-md" py="8px" fontSize="28px" fontStyle="italic" fontWeight="800">
		    		{ userData?.activePlan?.type === 'fuel' ? petrolEntriesAmount : userData?.entries }
		    	</Text>

		    	{ countActivePlans > 1 &&
					<Tooltip 
			          label="Shows combined benefits across all active subscriptions" 
			          bg={ttpBgColor}
			          color={ttpTextColor}
			          fontWeight="400"
			          fontSize="12px"
			          borderRadius="4px"
			          maxW="198px"
			          padding="4px 8px"
			          aria-label="tooltip" 
			          hasArrow>
			          <IconButton
			              icon={<Info2Icon fontSize="18px" color="#9FABCB" _hover={ isDark ? {color: 'white'} : {color: '#0E1633'}} />}
			              variant="ghost-sx"
			              size="sm"
			              w="8px"
			              top="0px"
			              right="0px"
			              position="absolute"
			              aria-label=""
			            />
				      </Tooltip>
				    }
		    </Card>

		    <Card style={styleCard}>
		    	{ isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader}>
		    		Prize value of upcoming prizes
		    	</Text>
		    	<Text pt="8px" variant="title-md" fontSize="28px" fontStyle="italic" fontWeight="800">
		    		$1,000,000
		    	</Text>
		    </Card>

		    <Card style={styleCard}>
		        { isDark ? <Lines className="abstract-lines" /> : <LinesWhite className="abstract-lines" style={{ opacity: 0.3 }} /> }

		    	<Text style={styleHeader}>
		    		Prize value of current prizes
		    	</Text>
		    	<Text pt="8px" variant="title-md" fontSize="28px" fontStyle="italic" fontWeight="800">
		    		$800,000
		    	</Text>
		    </Card>
		</Grid>
	);
};

export default Prizes;